import React from 'react';
import { getAssetByKey } from './app-assets';

export default function AssetImage({ srcKey, alt = '', className = '' }) {
  const assetUrl = getAssetByKey(srcKey);

  if (!assetUrl) {
    return null;
  }

  return (
    <img
      className={className ? `wt-asset-image ${className}` : 'wt-asset-image'}
      src={assetUrl}
      alt={alt}
    />
  );
}
